import React from 'react';
import styles from './loader.module.css';
import logo_bg from '../../images/logo_bg.svg';
import logo_letter from '../../images/logo_letter.svg';

type TFullScreenLoaderProps = {
  /** Тёмно-синий фон панели вместо чёрного фона сайта. */
  panel?: boolean;
  caption?: string;
};

/**
 * Полноэкранный загрузчик с логотипом: проверка входа в ЛК, первая загрузка
 * панели. Перекрывает весь экран (включая сайдбар кабинета), чтобы
 * пользователь не взаимодействовал с ЛК, пока сессия ещё не восстановлена.
 */
const FullScreenLoader: React.FC<TFullScreenLoaderProps> = ({ panel = true, caption = 'Загрузка' }) => (
  <div className={`${styles.screen} ${panel ? styles.screenPanel : ''}`} role="status" aria-label={caption}>
    <div className={styles.logo} aria-hidden="true">
      <img className={styles.logoBg} src={logo_bg} alt="" />
      <img className={styles.logoLetter} src={logo_letter} alt="" />
    </div>
    <span className={styles.caption}>{caption}</span>
  </div>
);

export default FullScreenLoader;
